import React from "react";
import MainContainer from "../../container/MainContainer";
import { Link } from "react-router-dom";
import Arrow from "../../images/Arrow-Right.svg";
import Expiration from "./Expiration";

const CreateDeal = () => {
  return (
    <MainContainer>
      <section className="post-block event-block">
        <div className="main-title">
          <div className="back-button">
            <Link to="/event">
              <img src={Arrow} alt="arrow right" />
            </Link>
            <h1>Edit Deals</h1>
          </div>
          <div className="edit-btn">
            <button>Save</button>and
            <button>exit</button>
          </div>
        </div>
        <div className="event-step-cover">
          <ul className="eventstep-menu">
            <li className="active">
              <p>1. General info</p>
            </li>
            <li>
              <p>2. Expiration</p>
            </li>
            <li>
              <p>3. Review & Publish</p>
            </li>
          </ul>
          {/* <Generalinfo/> */}
          <Expiration />
          {/* <ReviewPublish/> */}
        </div>
      </section>
    </MainContainer>
  );
};

export default CreateDeal;
